
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_pcgz5_psjd7_13",
  "slider": "awsui_slider_pcgz5_psjd7_50",
  "slider-track": "awsui_slider-track_pcgz5_psjd7_54",
  "slider-range": "awsui_slider-range_pcgz5_psjd7_54",
  "disabled": "awsui_disabled_pcgz5_psjd7_69",
  "readonly": "awsui_readonly_pcgz5_psjd7_73",
  "error": "awsui_error_pcgz5_psjd7_82",
  "warning": "awsui_warning_pcgz5_psjd7_85",
  "active": "awsui_active_pcgz5_psjd7_88",
  "error-active": "awsui_error-active_pcgz5_psjd7_91",
  "warning-active": "awsui_warning-active_pcgz5_psjd7_94",
  "labels": "awsui_labels_pcgz5_psjd7_105",
  "labels-noref": "awsui_labels-noref_pcgz5_psjd7_111",
  "labels-reference": "awsui_labels-reference_pcgz5_psjd7_114",
  "labels-min": "awsui_labels-min_pcgz5_psjd7_121",
  "labels-max": "awsui_labels-max_pcgz5_psjd7_127",
  "labels-aria-description": "awsui_labels-aria-description_pcgz5_psjd7_135",
  "ticks": "awsui_ticks_pcgz5_psjd7_153",
  "ticks-wrapper": "awsui_ticks-wrapper_pcgz5_psjd7_159",
  "tick": "awsui_tick_pcgz5_psjd7_153",
  "middle": "awsui_middle_pcgz5_psjd7_174",
  "filled": "awsui_filled_pcgz5_psjd7_177",
  "tooltip-thumb": "awsui_tooltip-thumb_pcgz5_psjd7_205",
  "thumb": "awsui_thumb_pcgz5_psjd7_218",
  "min": "awsui_min_pcgz5_psjd7_254",
  "max": "awsui_max_pcgz5_psjd7_257"
};
  